





import { Vue, Component, Provide, Watch } from 'vue-property-decorator';
import { get, sample } from 'lodash-es';
import qs from 'qs';
import Raven from 'raven-js';
import { Progress, store } from './core';
import { autobind } from 'core-decorators';
import { httpClient } from '../../service/http';
// import * as Loading from '../../component-dev/loading/index';
import { IS_ANDROID, IS_MQQ, IS_WEIXIN, IS_ZXG } from '../../service/platform/environment';
import config from './config.json';
import Dialog from '../../component-dev/dialog';
import Backdrop from '../../component-dev/backdrop';
import Button from '../../component-dev/button';
import { auth } from '../../service/auth';
import { sdk } from '../../service/platform';
import { makeStatReportParam } from '../../service/stat/Directive';
import { stat } from '../../service/stat';
@Component({})
export default class Page extends Vue {
	@Provide()
	store = store;
	
	loadingHandler: any = null;
	errorDialogConfig: any = {
		// 羊毛党
		51093118: {
			message: '很抱歉，您暂未获得本次活动参与机会',
		},
		// 未实名
		51093107: {
			message: '为保证奖励发放，要先完成实名认证喔',
		},
		// 已使用别的账号
		51093109: {
			message: '已使用其他账号参与活动啦',
		},
		// 已在H5端参与
		51093121: {
			message: '已在微证券参与活动啦',
		},
		// 已在app端参与
		51093122: {
			message: '已在自选股参与活动啦',
		},
	};
    
	// 移除分享功能 20190214by jenniferliu
	// beforeRouteEnter(to: any, from: any, next: any) {
	// 	next((vm: any) => vm.setDefaultShareData());
	// }

	// beforeRouteUpdate(to: any, from: any ,next: any) {
	// 	this.setDefaultShareData();
	// 	next();
	// }
	
	/***
	 * 配置全局默认分享
	 */
	setDefaultShareData() {
		const shareEventEmitter = sdk.updateShareInfo({
			...sample(config.SHARE_NORMAL),
			image: require('./images/share-1.png'),
			link: 'https://wzq.tenpay.com/activity/page/190115newyear/?' + qs.stringify({
				stat_data: (this.isZxg ? 'Otw37p00gf174' : 'osz92p00gf174'),
				_from: this.isZxg ? 'zxg' : 'wzq',
			})
		});
		this.store.dispatch('updateShareEventEmitter', shareEventEmitter);
	}

	/***
	 * 展示报错弹窗
	 * @param content
	 * @param callback
	 */
	showErrorDialog(content: any, callback = () => location.reload(), code?: any) {
		const ButtonComponent = Button as any;
		const unmount = Backdrop.mount({
			source: 'page',
			target: 'root',
			applyFilterFor: '#root',
			content: (
				<div class="layout-column layout-align-center-center">
					<Dialog>
						<template slot="main">
							<div class="error-dialog-content">{content}<span class="error-code">{code}</span></div>

						</template>
						<template slot="footer">
							<ButtonComponent class="glyph-font" nativeOnClick={() => {
								callback();
								unmount();
							}}>我知道了</ButtonComponent>
						</template>
					</Dialog>
				</div>
			)
		}, this.$createElement);
	}


	get isZxg() {
		const query = qs.parse(location.search.substring(1));
		return IS_MQQ ||
			IS_ZXG ||
			this.$route.query.from === 'zxg' ||
			query.from === 'zxg' || query._from === 'zxg' || this.$route.query._from === 'zxg';
	}

	async beforeMount() {
		if (IS_ZXG) {
			sdk.waitForJSBridge().then(() => {
				if (window.StockJSBridge) {
					window.StockJSBridge.invoke('settitle', {
						title: '腾讯自选股'
					});
					window.StockJSBridge.invoke('setFunctionButton', {
						text: 'refresh',
						event: 'refresh',
					});
					window.StockJSBridge.on('refresh', (data) => {
						if (!data['err_msg']) {
							window.location.reload();
						}
					});
				}
			});
		}
		if (this.isZxg) {
			document.title = '腾讯自选股';
		} else {
			document.title = '腾讯微证券';
		}
		try {
			if (IS_WEIXIN || IS_ZXG || IS_MQQ) {
				// if (!this.loadingHandler) {
				// 	this.loadingHandler = Loading.show(this.$createElement, this.isZxg ? 'zxg' : 'wzq');
				// }
				if(IS_WEIXIN || IS_ZXG ) {
					await auth.requireLogin();
				}
				
			} else {
				if (this.isZxg) {
					this.store.dispatch('jumpToZxgApp');
				} else {
					// this.showSubscribeBackdrop();
				}
				return;
			}
		} catch (e) {
			this.showErrorDialog('你需要登录才可以参加活动哦');
		}

		this.$nextTick(() => {
			if (!auth.isLogin()) return;
			// this.addHttpInterceptor();
		});
	}
}   
    
